import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'
import { useApiErrorHandler } from '../../../useApiErrorHandler'

interface UpdateHashtagData {
  id: string
  name?: string
  contactAccountIds?: string[]
}

const updateHashtag = async (data: UpdateHashtagData): Promise<void> => {
  const { id, ...updateData } = data
  await api.put(`/hashtag/${id}`, updateData)
}

export const useUpdateHashtag = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()
  const handleApiError = useApiErrorHandler()

  return useMutation<void, Error, UpdateHashtagData>({
    mutationFn: updateHashtag,
    onSuccess: async (_, variables) => {
      showSuccessToast(t('toast.success'), t('toast.hashtagUpdated'))
      // Invalidate both the list and the specific hashtag
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['hashtags'] }),
        queryClient.invalidateQueries({ queryKey: ['hashtag', variables.id] }),
        queryClient.invalidateQueries({ queryKey: ['hashtag-contacts', { id: variables.id }] }),
      ])
    },
    // A refused save says so instead of failing in silence.
    onError: handleApiError,
  })
}

